

<div #myModal class="modal fade" id="modal-lg">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Búsqueda de categoria.</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
  
  
  
        <div class="modal-body">
  
  
          <div class="card-tools">
           
           
  
              <div class="input-group-append">
                <input type="text" [(ngModel)]='txtBuscar' name="table_search" class="form-control float-right" placeholder="Escriba aquí" autocomplete="off">
                <button type="button" class="btn btn-default" (click)="OnBuscarPorDescripcion()">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>
          <table class="table table-bordered">
            <thead>
              <tr  >
                <th style="width: auto">Código </th>
                <th style="width:auto">Descripción</th>
                 <th style="width: auto"></th>
                 <th style="width: auto"></th>
              </tr>
            </thead>
            <tbody>
              <tr  *ngFor="let dato of categoriadto; let i=index">
                <td >{{dato.idCategoria}}</td>
                <td>{{dato.descripcion}}</td>
                <td style="text-align: center;"><img  src={{urlServerUpload$}}{{dato.imagen}}{{tipoMedia$}}  style="width: 30%;height: 30%;"></td>
                <td >  <a class="btn btn-app" (click)="OnSeleccionarCategoria(dato.idCategoria)">
                  <i class="fas fa-edit"></i> Editar
                </a></td>
              </tr>
              
              
            </tbody>
          </table>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
         
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
  
  <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="card-body">
            <a class="btn btn-app bg-secondary" (click)="OnAbrirBusqueda()">
           
              <i class="fas fa-barcode" ></i> Buscar
            </a>
            </div>
          <!-- left column -->
          <div class="col-md-8">
           
  <div class="card card-primary">
      <div class="card-header">
        <h3 class="card-title">Datos de la Categoría</h3>
      </div>
      <!-- /.card-header -->
      <!-- form start -->
      <form  [formGroup]="formCategoria"   >
        <div class="card-body">
  
          <div class="form-group">
            <label for="labelImagen1">Imagen</label>
            <div class="input-group">
              <div class="custom-file">
                <input type="file" class="custom-file-input" accept=".jpg,.png" id="inputFile" (change)="onFileSelected($event)" #fileUpload>
                <label class="custom-file-label" for="lblarchivo">{{this.nombreArchivo}}</label>
              </div>
              
            </div>
  
            <div *ngIf="errorForm[0] == '1'">
              <label for="label1"><code>Debe Seleccionar seleccionar alguna imagen.</code></label>
            </div>
  
            <div *ngIf="previsualizacion">
              <img width="100px" [src]="previsualizacion" alt="50px">
          </div>
          </div>
  
  
          <div class="form-group">
            <label for="label1">Descripción</label> 
            <input type="text" class="form-control"  placeholder="Escriba una descripción" maxlength="30" formControlName="txtDescripcion" >
          </div>
  
          <div *ngIf="errorForm[1] == '1'">
            <label for="label1"><code>No puede quedar vacío.</code></label>
          </div>
  
         
  
         
        </div>
        <!-- /.card-body -->
  
        
        <div class="card-footer" style="text-align: center;">
            <div *ngIf="esperar == true" class="overlay"><i class="fas fa-3x fa-sync-alt fa-spin"></i><div class="text-bold pt-2">Espere...</div></div>
            <button type="button" class="btn btn-primary" (click)="OnGuardarCategoria()">{{this.tituloBotonGuardar}}</button>
            <button type="button" class="btn btn-danger" >Eliminar</button>
           
          </div>
       
  
      </form>
    </div>
  
  
  
   
  
  
  
  
  
  
  </div>
  </div>
  </div>
  </section>
  
  
